import { create } from 'zustand';
import { AlertTriangle, ShieldCheck } from 'lucide-react';
import { Button } from './button';

export const useConfirmation = create((set) => ({
  request: null,
  confirm: (options) => new Promise((resolve) => set({ request: { ...options, resolve } })),
  close: (result = false) => set((state) => {
    state.request?.resolve(result);
    return { request: null };
  }),
}));

export function ConfirmationViewport() {
  const request = useConfirmation((state) => state.request);
  const close = useConfirmation((state) => state.close);
  if (!request) return null;
  const danger = request.tone === 'danger';
  const Icon = danger ? AlertTriangle : ShieldCheck;
  return <div className="fixed inset-0 z-[100] grid place-items-center overflow-hidden bg-black/75 p-4 backdrop-blur-sm" onMouseDown={() => close(false)}>
    <div className="panel-corners w-full max-w-md border border-white/12 bg-[#081019] shadow-[0_30px_110px_rgba(0,0,0,.72)]" onMouseDown={(event) => event.stopPropagation()}>
      <div className="flex items-start gap-3 p-4"><span className={`grid size-9 shrink-0 place-items-center border ${danger ? 'border-rose-400/25 bg-rose-400/[.07] text-rose-300' : 'border-cyan-300/25 bg-cyan-300/[.07] text-cyan-300'}`}><Icon size={16}/></span><div className="min-w-0"><p className="text-[8px] font-black uppercase tracking-[.16em] text-slate-600">Confirm action</p><h2 className="mt-1 text-sm font-black text-slate-100">{request.title}</h2><p className="mt-2 text-xs leading-5 text-slate-500">{request.message}</p></div></div>
      <div className="flex justify-end gap-2 border-t border-white/8 px-4 py-3"><Button variant="secondary" className="h-8 px-3 text-xs" onClick={() => close(false)}>Cancel</Button><Button variant={danger ? 'danger' : 'primary'} className="h-8 px-3 text-xs" onClick={() => close(true)}>{request.confirmLabel ?? 'Confirm'}</Button></div>
    </div>
  </div>;
}
